<template>
  <div class="spinner-container">
    <div class="spinner">
    </div>
    <asset-v3
      class="logo"
      dir="icons"
      name="parcelex-X.svg"
    />
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'LoadingSpinner',
  components: {
    AssetV3,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .spinner-container {
    position: relative;
    width: 64px;
    height: 64px;
  }

  .logo {
    display: inline-block;
    text-align: center;
    position: absolute;
    left: 50%;
    bottom: 21px;
    transform: translateX(-50%);
  }

  .spinner {
    position: relative;
    width: 64px;
    height: 64px;
    background-color: $white;
    border-radius: 50%;
    border: 4px solid $primary-100;
    border-left-color: $primary-500;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg)}
  }
</style>
